module.exports = __webpack_public_path__ + "img/symbol_2.1f8eb1f4.png";